export const Settings = {
  sfx: true,
  bgm: true,
};
